import { useEffect, useState } from "react";
import { useCentralStore } from "../../store/appContext";
import ActionTypes from "../../store/actionTypes";
import { useNavigate } from "react-router-dom";
import API from "../../api";
import OtpPage from "./otp";
import Spinner from "../../components/common/spinner/spinner";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Image } from "antd";
import classNames from "classnames";
import { jwtDecode } from "jwt-decode";
import { getCarrierByDomain } from "../../domain";
import AuthService from "../../utils/authSerivce";
import config from "../../config/config";
import LockIcon from '../../assets/icons/password-lock'

const LoginForm = ({ }) => {
  const [{ userLoggedIn, email, password, loadingData, carrierThemeData }, dispatch] = useCentralStore();
  const [loginerror, setLoginerror] = useState()
  const [emailerror, setEmailerror] = useState()
  const [passworderror, setPasswordError] = useState()
  const navigate = useNavigate();

  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING_DATA, payload: action });
  };

  const validateEmail = (values) => {
    const errors = {}

    if (!values) {
      setEmailerror('Email Address Required')
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values)) {
      setEmailerror('Invalid Email address')
    } else {
      setEmailerror('')
    }
    return errors
  }
  const validatePassword = (values) => {
    const errors = {}

    if (!values) {
      setPasswordError('Password is Required')
    } else {
      setPasswordError('')
    }
    return errors
  }

  const Email = (e) => {
    setLoginerror('')
    setPasswordError('')
    dispatch({
      type: ActionTypes.SET_EMAIL_ADDRESS,
      payload: e.target.value,
    });
    validateEmail(e.target.value)
  };
  const Password = (e) => {
    setLoginerror('')
    setPasswordError('')
    dispatch({
      type: ActionTypes.SET_PASSWORD,
      payload: e.target.value,
    });
    validatePassword(e.target.value)
  };

  useEffect(() => {
    if (userLoggedIn) {
      OtpPage();
    }
  }, [userLoggedIn]);

  const login = () => {
    setLoading(true)
    //  API[ActionTypes.OTP_REQUEST]("mrunal.deshmukh@asurion.com", "Madhavi@123")
    let payload = {
      GetUserDetailRequest: {
        email: email
      }
    }
    API[ActionTypes.GET_USER_DETAILS](payload)
        .then((userData) => {
          if(userData?.data?.Attributes?.Value?.toLowerCase() === getCarrierByDomain()?.toLowerCase()) {
            API[ActionTypes.VALIDATE_EMAIL_PASSWORD](email, password)
            .then((data) => {
              setLoading(false);
              if (data?.challengeName === 'NEW_PASSWORD_REQUIRED') {
                navigate('/changePassword')
              } else if (data?.challengeName === 'CUSTOM_CHALLENGE') {
                dispatch({
                  type: ActionTypes.SET_USER_LOGGED_IN,
                  payload: true,
                });
                navigate("/otpPage");
              }
            })
            .catch((err) => {
              setLoading(false)
              if (err) {
                setLoginerror('Invalid Username or Password')
              }
              console.log(`error is ${err}`);
            });
          } else {
            setLoading(false);
            setLoginerror('User not allowed to login!')
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(`error is ${err}`);
          setLoginerror('User not allowed to login!')
        })


    // API[ActionTypes.VALIDATE_EMAIL_PASSWORD](email, password)
    //   .then((data) => {
    //     API[ActionTypes.GET_USER_DETAILS](payload)
    //     .then((userData) => {
    //       setLoading(false);
    //       if(userData?.data?.Attributes?.Value?.toLowerCase() === getCarrierByDomain()?.toLowerCase()) {
    //         if (data?.challengeName === 'NEW_PASSWORD_REQUIRED') {
    //           navigate('/changePassword')
    //         } else if (data?.challengeName === 'CUSTOM_CHALLENGE') {
    //           dispatch({
    //             type: ActionTypes.SET_USER_LOGGED_IN,
    //             payload: true,
    //           });
    //           navigate("/otpPage");
    //           // console.log('OTP Page', data);
    //           // dispatch({
    //           //   type: ActionTypes.SET_USER_DATA,
    //           //   payload: { access_token: idToken }
    //           // });
    //           // dispatch({
    //           //   type: ActionTypes.SET_USER_DETAILS,
    //           //   payload: email
    //           // });
    
    //         // }
    //       }
    //       } else {
    //         setLoginerror('User not allowed to login!')
    //       }

    //     })
    //     .catch((err) => {
    //       setLoading(false);
    //       console.log(`error is ${err}`);
    //       setLoginerror('User not allowed to login!')
    //     })
    //   })
    //   .catch((err) => {
    //     setLoading(false)
    //     if (err) {
    //       setLoginerror('Invalid Username or Password')
    //     }
    //     console.log(`error is ${err}`);
    //   });

  }

  const { theme } = carrierThemeData;

  const dynamicStyle = {
    '--dynamic-color': theme?.colors?.primary,
    // '--font-color': theme?.colors?.textWhiteColor,
    '--background-color': theme?.colors?.primary
};

  return (<>
    {loadingData && <Spinner showOverlay={true} />}
    {carrierThemeData && <div className="bg-white h-screen text-black"
    // style={{ 
    //   background: `${theme?.colors?.primary} url(${theme?.backgroundImg})`
    //  }}
     >
      <div className="background-container">
        {/* <div className="boxone" style={dynamicStyle}></div>
        <div className="box" style={dynamicStyle}></div> */}
        <div className="flex justify-between">
          <div className="content">
            <img className="mx-auto h-20" src={theme?.logo} />
            {/* <Image className="mx-auto mt-28 h-32 w-32" src={require(`${theme?.logo}`)} /> */}
            <div className={``}>
              <div className={`Logintitle text-center`}>
                <p className={`texts`}>
                  Sign in and start managing your
                  <p className={`textfonts`}>{carrierThemeData?.program}</p>
                </p>
              </div>
              <br></br>
              <div class="relative">
                <input
                  type="text"
                  id="floating_outlined"
                  class="block  px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer"
                  placeholder="Email Address"
                  defaultValue={email}
                  onChange={Email}
                />
                <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 color:gray">Email Address</label>
              </div>
              <br />
              <div class="relative">
                {/* <LockIcon className="absolute" /> */}
                <input
                  type="password"
                  id="floating_outlined"
                  class="block  px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-black-300 appearance-none dark:text-white dark:border-black-600 dark:focus:border-black-500 focus:outline-none focus:ring-0 focus:border-black-600 peer"
                  placeholder="Password"
                  defaultValue={password}
                  onChange={Password}

                />
                <label for="floating_outlined" className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 text-gray-100">
                  Password
                </label>
              </div>
              <div className="mt-5 mx-m15 flex justify-center">
                <button
                  id="continue"
                  onClick={login}
                  className={`px-4 py-2 w-full rounded-xs backgroundStyle ${getCarrierByDomain()?.toLowerCase() === 'celcom' ? 'text-white' : 'textFontStyle'} font-bold text-sm`}
                  type="submit"
                  style={dynamicStyle}
                // disabled={logindisable}
                >
                  Login
                </button>
              </div>
              {loginerror && <p className="error">{loginerror}</p>}
              {emailerror && !loginerror && <p className="error">{emailerror}</p>}
              {passworderror && !emailerror && !loginerror && <p className="error">{passworderror}</p>}
            </div>
          </div>
          <div className="flex justify-end w-1/2">
            <LazyLoadImage
              className="h-screen"
              // alt={image.alt}
              loading="lazy"
              // src={require('../../assets/icons/LaptopLogin.png')} />
              src={require('../../assets/icons/LoginImg.png')} />
          </div>
        </div>
      </div>
    </div>}
  </>
  );
};

export default LoginForm;
